import { render, staticRenderFns } from "./input.vue?vue&type=template&id=470e75ac&scoped=true&"
import script from "./input.js?vue&type=script&lang=js&"
export * from "./input.js?vue&type=script&lang=js&"
import style0 from "./input.scss?vue&type=style&index=0&id=470e75ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e75ac",
  null
  
)

export default component.exports